import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {employeePromotionTableReady,rowsPerPageState,searchTextState,paginationState,employeePromotionIdForAction,previousFilterCity,previousFilterStartDate,previousFilterEndDate} from '../redux/employee_promotion'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/employeePromotionTable.css'


import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'


import {Cities} from '../../../common/DropDowns/index'



import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'


import * as Helpers from '../../../common/helpers'


function filterUnwantedData(employeePromotionData) {
    let array = []
    if (employeePromotionData && employeePromotionData.data && employeePromotionData.data.list) {
        array = employeePromotionData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""

            newLineData.code_at_promotion = lineData.code_at_promotion ? lineData.code_at_promotion : ""
            newLineData.promoted_date = lineData.promoted_date ?  Helpers.getDateFormatForUTC(lineData.promoted_date) : ""
            newLineData.remarks = lineData.remarks ? lineData.remarks : ""
            newLineData.created = lineData.created ? Helpers.getDateFormatForUTC(lineData.created) : ""

            newLineData.reason_name= lineData.reason && lineData.reason.name ? lineData.reason.name : ""

            newLineData.created_by=lineData.created_user && lineData.created_user.created_employee_profile && lineData.created_user.created_employee_profile.name ? lineData.created_user.created_employee_profile.name + " - "+lineData.created_user.created_employee_profile.code : ""


            newLineData.employee_id= lineData.employee && lineData.employee.code ? lineData.employee.code : ""
            newLineData.employee_name= lineData.employee && lineData.employee.name ? lineData.employee.name : ""
           
            newLineData.city_name= lineData.employee && lineData.employee.city && lineData.employee.city.name ? lineData.employee.city.name : ""
           
            newArray[i] = newLineData
        }
    }
    return newArray
}


class EmployeePromotionTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            employeePromotionData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_city_id:"",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: "",
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            ranges: {
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Yesterday': [moment().subtract(1, 'day'), moment().subtract(1, 'day')]
            }
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null

        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(employeePromotionTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.EMPLOYEE_PROMOTION_TABLE))
        this.props.dispatch(subHeaderDataUpdate())


        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

            let previousFilterCity=""

            let previousFilterStartDate= moment().startOf('month').format("YYYY-MM-DD")
            let previousFilterEndDate=  moment().format("YYYY-MM-DD")

         if (this.props.employee_promotion && this.props.employee_promotion.previousFilterCity && this.props.employee_promotion.previousFilterCity!==undefined) {
            previousFilterCity=this.props.employee_promotion.previousFilterCity
         }         



         if (this.props.employee_promotion && this.props.employee_promotion.previousFilterStartDate && this.props.employee_promotion.previousFilterStartDate!==undefined) {
            previousFilterStartDate=this.props.employee_promotion.previousFilterStartDate
         }         

         if (this.props.employee_promotion && this.props.employee_promotion.previousFilterEndDate && this.props.employee_promotion.previousFilterEndDate!==undefined) {
            previousFilterEndDate=this.props.employee_promotion.previousFilterEndDate
         }
         
         
         this.setState({
              filter_city_id:previousFilterCity,
              startDate:previousFilterStartDate,
              endDate:previousFilterEndDate
         },() => {
            this.getEmployeePromotionData();
        });

        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }

     createCSVData(csvData) {
        let kitchenList = []
        if (csvData) {
            kitchenList = JSON.parse(JSON.stringify(csvData))
            kitchenList = createXLSheetdata(kitchenList)
        }
        this.CSVData = kitchenList
    }


    
    getEmployeePromotionData = () => {
        apiService.getEmployeePromotionData(this.state.startDate,this.state.endDate, this.state.filter_city_id)
            .then(employeePromotionData => {
                if (employeePromotionData && this.isComponentMounted) {
                    this.validateBuildNumber(employeePromotionData)
                    if (employeePromotionData.status === "SUCCESS") {
                        let array = filterUnwantedData(employeePromotionData), pageNo = 1
                        if (this.props.employee_promotion && this.props.employee_promotion.previousPaginationValue) {
                            pageNo = this.props.employee_promotion.previousPaginationValue
                        }
                        this.setState({
                            employeePromotionData: array,
                            page: pageNo,
                        })


                        this.createCSVData(array)
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: employeePromotionData.reason ? employeePromotionData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(employeePromotionTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(employeePromotionTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

   

    

    cityChange = (data) => {

        
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterCity(""))
              this.setState({
                filter_city_id :"",            
            })
        }else{
            this.props.dispatch(previousFilterCity(data.value))
            this.setState({
            filter_city_id :data.value,
            
            })
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.employee_promotion && this.props.employee_promotion.previousRowsPerPageValue) {
            value = this.props.employee_promotion.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

    




     onApplyEvent = (event, picker) => {
        let endDate = moment(picker.endDate)

        let api_start_date=moment(picker.startDate).format("YYYY-MM-DD")
        let api_end_date=moment(picker.endDate).format("YYYY-MM-DD")
        if (endDate.diff(endDate, 'months', true) > 1) {
            this.dialog.show({
                title: "Date chosen is greater than one month",
                body: 'Please choose any Dates within one month and then try again',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        } else {
             this.props.dispatch(previousFilterStartDate(api_start_date))
                this.props.dispatch(previousFilterEndDate(api_end_date))

                this.setState({
                    startDate: api_start_date,
                    endDate: api_end_date
                })
        }
    }


    createCustomToolBar = props => {


        let employeePromotionListFilename = "employee_promotion_list_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"


        let startDate = "", endDate = "", start = "", end = "", label = ""

        startDate = moment(this.state.startDate)
        endDate = moment(this.state.endDate)

        start = moment(startDate).format('DD-MM-YYYY')
        end = moment(endDate).format('DD-MM-YYYY')

        label = start + ' to ' + end;

        if (start === end) {
            label = start
        }

        let firstComponent = ''

        
            firstComponent = <div className="col-md-3 col-sm-12 col-xs-12 div-margins">
                <div className="form-group">
                    <DateRangePicker startDate={startDate}
                        endDate={endDate}
                        ranges={this.state.ranges}
                        showDropdowns={true}
                        onApply={this.onApplyEvent}>
                        <button className="date-picker-button">
                            <div className="pull-left"><i className="fa fa-calendar" /></div>
                            <span style={{ textAlign: 'center' }}>{label}</span>
                            <div className="pull-right">
                                <span className="caret"></span>
                            </div>
                        </button>
                    </DateRangePicker>
                </div>
            </div>


        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   {(() =>{

                    if(Helpers.checkPrivileges("/dashboard/employeePromotion/add",this.props.user)){
                    return(
                        <div className="col-md-1 col-sm-12 col-xs-12 div-margins">
                            <button className="btn btn-primary button-custom"
                                    style={{ marginLeft: "5px" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.props.dispatch(employeePromotionIdForAction())
                                        this.props.history.push("/dashboard/employeePromotion/add")
                                    }}>
                                    Add
                                </button>
                         </div>

                        )
                      }
                   })()}


                    {firstComponent}


                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <Cities cityChange={this.cityChange} selectedValue={this.state.filter_city_id} />   
                    </div>
                    </div>
                   
                   

                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredKitchenStaffList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>

                        <CSVLink
                            data={this.CSVData}
                            className="btn btn-primary button-custom"
                            style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                            filename={employeePromotionListFilename}>
                            Export
                        </CSVLink>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.employeePromotionData.length>=(this.props.employee_promotion.previousPaginationValue*this.props.employee_promotion.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.employee_promotion.previousPaginationValue*this.props.employee_promotion.previousRowsPerPageValue)-this.props.employee_promotion.previousRowsPerPageValue+1} to {this.props.employee_promotion.previousPaginationValue*this.props.employee_promotion.previousRowsPerPageValue} of {this.state.employeePromotionData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.employee_promotion.previousPaginationValue*this.props.employee_promotion.previousRowsPerPageValue)-this.props.employee_promotion.previousRowsPerPageValue+1} to {this.state.employeePromotionData.length} of {this.state.employeePromotionData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredKitchenStaffList = () => {
       
        this.props.dispatch(employeePromotionTableReady(false))
        this.resetSearchAndPagination()
        this.getEmployeePromotionData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    


    resetFilterValues = () => {
        this.props.dispatch(employeePromotionTableReady(false))
        this.setState({
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            filter_city_id:"",
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterCity(""))          
            this.props.dispatch(previousFilterStartDate(moment().startOf('month').format("YYYY-MM-DD")))
            this.props.dispatch(previousFilterEndDate(moment().format("YYYY-MM-DD")))

            this.getEmployeePromotionData()
        });

        
    }


    actionButtonsCreator = (cell, row) => {
       
        let updatBtn=""

      return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{updatBtn}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.employee_promotion && this.props.employee_promotion.previousPaginationState
            && this.props.employee_promotion.previousPaginationState !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }


    render() {
        let sizeperPage = 15

        if (this.props.employee_promotion && this.props.employee_promotion.previousRowsPerPageValue) {
            sizeperPage = this.props.employee_promotion.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="employeePromotions-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.employeePromotionData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}>
  {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                    <TableHeaderColumn
                        dataField="code_at_promotion"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Emp. Code at Promotion
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="employee_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="employee_id"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Employee Code
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="city_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                      City
                    </TableHeaderColumn>
                    
                    
                    <TableHeaderColumn
                        dataField="reason_name"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Reason
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="remarks"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Remarks
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="promoted_date"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Promotiond Date
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="created"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Created on
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="created_by"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Promoted By
                    </TableHeaderColumn>
                    
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        employee_promotion: state.employee_promotion
    }
}

export default connect(mapStateToProps)(withRouter(EmployeePromotionTable))


// WEBPACK FOOTER //
// ./src/modules/Employee Promotion/Components/EmployeePromotionTable.js